import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["min", "max"]

import {ref} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AudioSlider',
  props: /*@__PURE__*/_mergeModels({
  min: {
    type: Number,
    default: 0,
  },
  max: {
    type: Number,
    default: 100,
  },
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(['wrapinput'], ["update:modelValue"]),
  setup(__props, { emit: __emit }) {


const emit = __emit;
const [model] = _useModel(__props, "modelValue")
const inputRef = ref<HTMLInputElement | null>(null);
const onWrapperClick = (e: PointerEvent) => {
  const percent = e.offsetX / e.target.getBoundingClientRect().width;
    emit('wrapinput', percent);
};
const onWrapperMove = (e: TouchEvent) => {
  const wrapper = e.target.getBoundingClientRect() as DOMRect
  const offsetX = Math.max(0,e.touches.item(0).clientX - wrapper.x)
  const maxWidth = wrapper.width
  const percent = Math.min(1, offsetX/maxWidth)
  emit('wrapinput', percent);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "audio-slider",
    onClick: _withModifiers(onWrapperClick, ["self"]),
    onTouchmove: _withModifiers(onWrapperMove, ["stop"])
  }, [
    _withDirectives(_createElementVNode("input", {
      ref_key: "inputRef",
      ref: inputRef,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
      min: __props.min,
      max: __props.max,
      type: "range",
      style: _normalizeStyle(`--ProgressPercent: ${_unref(model)}%`),
      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
    }, null, 44, _hoisted_1), [
      [_vModelText, _unref(model)]
    ])
  ], 32))
}
}

})